import React from 'react';
import { Text } from '@smarterservices/smarter-ui';

/**
 * A component that displays a label and text value in a consistent format.
 * 
 * @param {Object} props - Component props
 * @param {string} props.label - The label text to display (will be bolded)
 * @param {string|React.ReactNode} props.text - The text value to display after the label
 * @param {string} [props.variant='contentSmall'] - The text variant from SmarterUI Text component
 * @param {string} [props.labelWidth] - Optional width for the label (e.g., '100px', '8rem') to align labels in a column
 * @returns {React.ReactElement} A formatted label and text component
 * 
 * @example
 * // Basic usage
 * <LabelAndText label="Name" text="John Doe" />
 * 
 * @example
 * // With label width for alignment
 * <LabelAndText label="Email" text="john@example.com" labelWidth="100px" />
 * 
 * @example
 * // With custom variant
 * <LabelAndText label="Status" text="Active" variant="contentMedium" />
 */
const LabelAndText = (props) => {
  const labelStyle = props.labelWidth ? { display: 'inline-block', width: props.labelWidth } : {};

  return (
    <Text variant={props.variant || 'contentSmall'}>
      <b style={labelStyle}>{props.label}:</b> {props.text}
    </Text>
  );
};

export default LabelAndText;
